export const includesMatterport = 'Includes Matterport';
export const toggleLabel = 'toggle if service has matterport';
export const includesMatterportDescription = 'This toggle determines if Matterports show in the content tab';
export const errorUpdatingToggle = (message) => `Error updating: ${message}`;
export const updateToggleSuccess = (message) => `Successfully updated: ${message}!`;
